import React, { useState, useEffect } from 'react';
import { FaGraduationCap, FaBook, FaUniversity, FaGlobe, FaBriefcase, FaChevronRight, FaFlask, FaCalculator, FaLaptopCode, FaChartLine, FaBalanceScale } from 'react-icons/fa';

const CompetitiveExamsSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const examCategories = [
    {
      title: "School Programs",
      icon: <FaGraduationCap />,
      color: "#FF6B6B",
      exams: [
        {
          name: "Navodaya Vidyalaya (JNVST)",
          description: "Entrance exam for Classes 6 & 9 admission to Navodaya schools nationwide",
          icon: <FaBook />,
          gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          route: "/courses/navodaya"
        },
        {
          name: "Sainik School Entrance",
          description: "All India entrance examination for admission to Sainik Schools",
          icon: <FaGraduationCap />,
          gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
          route: "/courses/sainik-school"
        },
        {
          name: "Olympiad Programs",
          description: "IMO, NSO, IEO, ISSO - Building excellence in Science, Math & English",
          icon: <FaFlask />,
          gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
          route: "/courses/olympiad-training"
        },
        {
          name: "NTSE (National Talent Search)",
          description: "Premier scholarship program for Class 10 students nationwide",
          icon: <FaChartLine />,
          gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
          route: "/courses/ntse-training"
        },
        {
          name: "KVPY/INSPIRE Scholarship Program ",
          description: "KVPY is Now INSPIRE Scholarship Program, Kishore Vaigyanik Protsahan Yojana for science stream students",
          icon: <FaCalculator />,
          gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
          route: "/courses/kvpy-training"
        }
      ]
    },
    {
      title: "Foundation Programs (6th to 10th)",
      icon: <FaBook />,
      color: "#4ECDC4",
      exams: [
        {
          name: "IIT-JEE Foundation",
          description: "Early preparation for engineering aspirants from Class 6-10",
          icon: <FaLaptopCode />,
          gradient: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)",
          route: "/courses/iit-foundation"
        },
        {
          name: "NEET Foundation",
          description: "Medical entrance foundation course for aspiring doctors",
          icon: <FaFlask />,
          gradient: "linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)",
          route: "/courses/neet-foundation"
        },
        {
          name: "Foundation Mathematics",
          description: "Advanced mathematics for competitive exam preparation",
          icon: <FaCalculator />,
          gradient: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
          route: "/courses/foundation-math"
        },
        {
          name: "Foundation Science",
          description: "Comprehensive science program building strong fundamentals",
          icon: <FaFlask />,
          gradient: "linear-gradient(135deg, #ff6e7f 0%, #bfe9ff 100%)",
          route: "/courses/foundation-science"
        },
        {
          name: "Vedic Mathematics",
          description: "Ancient calculation techniques for speed and accuracy",
          icon: <FaCalculator />,
          gradient: "linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%)",
          route: "/courses/vedic-math"
        }
      ]
    },
    {
      title: "Professional Level (11th & 12th)",
      icon: <FaBriefcase />,
      color: "#FFD93D",
      exams: [
        {
          name: "IIT-JEE (Main & Advanced)",
          description: "Premier engineering entrance for IITs, NITs, and top institutions",
          icon: <FaLaptopCode />,
          gradient: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
          route: "/courses/iit-jee"
        },
        {
          name: "NEET-UG",
          description: "National medical entrance for MBBS, BDS, and AYUSH courses",
          icon: <FaFlask />,
          gradient: "linear-gradient(135deg, #f77062 0%, #fe5196 100%)",
          route: "/courses/neet"
        },
        {
          name: "BITSAT",
          description: "Birla Institute of Technology and Science admission test",
          icon: <FaLaptopCode />,
          gradient: "linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)",
          route: "/courses/bitsat"
        },
        {
          name: "VITEEE",
          description: "VIT Engineering Entrance Examination for top private institution",
          icon: <FaLaptopCode />,
          gradient: "linear-gradient(135deg, #fddb92 0%, #d1fdff 100%)",
          route: "/courses/viteee"
        },
        {
          name: "SRMJEEE",
          description: "SRM Joint Engineering Entrance Examination",
          icon: <FaLaptopCode />,
          gradient: "linear-gradient(135deg, #9890e3 0%, #b1f4cf 100%)",
          route: "/courses/srmjeee"
        }
      ]
    },
    {
      title: "Central University Exams",
      icon: <FaUniversity />,
      color: "#95E1D3",
      exams: [
        {
          name: "CUET (UG & PG)",
          description: "Common University Entrance Test for central universities admission",
          icon: <FaUniversity />,
          gradient: "linear-gradient(135deg, #13547a 0%, #80d0c7 100%)",
          route: "/courses/cucet-coaching"
        },
        {
          name: "JNU Entrance Exam",
          description: "Jawaharlal Nehru University entrance for various programs",
          icon: <FaUniversity />,
          gradient: "linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)",
          route: "/courses/jnu"
        },
        {
          name: "BHU UET & PET",
          description: "Banaras Hindu University Undergraduate & Postgraduate tests",
          icon: <FaUniversity />,
          gradient: "linear-gradient(135deg, #f77062 0%, #fe5196 100%)",
          route: "/courses/bhu"
        },
        {
          name: "DU JAT",
          description: "Delhi University Joint Admission Test for various courses",
          icon: <FaUniversity />,
          gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
          route: "/courses/du-jat"
        },
        {
          name: "IPU CET",
          description: "Guru Gobind Singh Indraprastha University Common Entrance Test",
          icon: <FaUniversity />,
          gradient: "linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)",
          route: "/courses/ipu-cet"
        }
      ]
    },
    {
      title: "Postgraduate Entrance Exams",
      icon: <FaGraduationCap />,
      color: "#A8E6CF",
      exams: [
        {
          name: "IIT-JAM",
          description: "Joint Admission Test for M.Sc. programs in IITs",
          icon: <FaFlask />,
          gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          route: "/courses/iit-jam"
        },
        {
          name: "GATE",
          description: "Graduate Aptitude Test in Engineering for M.Tech & PSU recruitment",
          icon: <FaLaptopCode />,
          gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
          route: "/courses/gate"
        },
        {
          name: "CAT",
          description: "Common Admission Test for IIMs and top B-Schools",
          icon: <FaBriefcase />,
          gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
          route: "/courses/cat"
        },
        {
          name: "XAT",
          description: "Xavier Aptitude Test for XLRI and associate institutions",
          icon: <FaBriefcase />,
          gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
          route: "/courses/xat"
        },
        {
          name: "MAT",
          description: "Management Aptitude Test for MBA/PGDM admissions",
          icon: <FaBriefcase />,
          gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
          route: "/courses/mat"
        },
        {
          name: "CMAT",
          description: "Common Management Admission Test by NTA",
          icon: <FaBriefcase />,
          gradient: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
          route: "/courses/cmat"
        },
        {
          name: "NET-JRF",
          description: "National Eligibility Test for Assistant Professor & Research",
          icon: <FaBook />,
          gradient: "linear-gradient(135deg, #ff6e7f 0%, #bfe9ff 100%)",
          route: "/courses/net-jrf"
        },
        {
          name: "NIMCET",
          description: "NIT MCA Common Entrance Test for MCA programs",
          icon: <FaLaptopCode />,
          gradient: "linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%)",
          route: "/courses/nimcet"
        },
        {
          name: "TISSNET",
          description: "Tata Institute of Social Sciences entrance for MA programs",
          icon: <FaUniversity />,
          gradient: "linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)",
          route: "/courses/tissnet"
        },
        {
          name: "AILET",
          description: "All India Law Entrance Test for NLU Delhi",
          icon: <FaBalanceScale />,
          gradient: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)",
          route: "/courses/ailet"
        }
      ]
    },
    {
      title: "Government Jobs & Services",
      icon: <FaBriefcase />,
      color: "#FFB6B9",
      exams: [
        {
          name: "UPSC CSE",
          description: "Civil Services Examination for IAS, IPS, IFS officers",
          icon: <FaBriefcase />,
          gradient: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
          route: "/courses/upsc"
        },
        {
          name: "SSC CGL",
          description: "Combined Graduate Level for Group B & C posts",
          icon: <FaBriefcase />,
          gradient: "linear-gradient(135deg, #f77062 0%, #fe5196 100%)",
          route: "/courses/ssc-cgl"
        },
        {
          name: "SSC CHSL",
          description: "Combined Higher Secondary Level Examination",
          icon: <FaBriefcase />,
          gradient: "linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)",
          route: "/courses/ssc-chsl"
        },
        {
          name: "RRB NTPC",
          description: "Railway Non-Technical Popular Categories recruitment",
          icon: <FaBriefcase />,
          gradient: "linear-gradient(135deg, #fddb92 0%, #d1fdff 100%)",
          route: "/courses/rrb-ntpc"
        },
        {
          name: "Bank PO/Clerk",
          description: "IBPS, SBI recruitment for Probationary Officers & Clerks",
          icon: <FaChartLine />,
          gradient: "linear-gradient(135deg, #9890e3 0%, #b1f4cf 100%)",
          route: "/courses/bank-po-training"
        }
      ]
    },
    {
      title: "Abroad Entrance Exams",
      icon: <FaGlobe />,
      color: "#C7CEEA",
      exams: [
        {
          name: "SAT",
          description: "Scholastic Assessment Test for US undergraduate admissions",
          icon: <FaGlobe />,
          gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          route: "/courses/sat"
        },
        {
          name: "GRE",
          description: "Graduate Record Examination for MS/MBA abroad",
          icon: <FaGlobe />,
          gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
          route: "/courses/gre"
        },
        {
          name: "GMAT",
          description: "Graduate Management Admission Test for global MBA programs",
          icon: <FaGlobe />,
          gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
          route: "/courses/gmat"
        },
        {
          name: "IELTS",
          description: "International English Language Testing System for study abroad",
          icon: <FaGlobe />,
          gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
          route: "/courses/ielts"
        },
        {
          name: "TOEFL",
          description: "Test of English as a Foreign Language for international students",
          icon: <FaGlobe />,
          gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
          route: "/courses/toefl"
        }
      ]
    },
    {
      title: "Law Entrance Exams",
      icon: <FaBalanceScale />,
      color: "#000000ff",
      exams: [
        {
          name: "CLAT",
          description: "Common Law Admission Test for National Law Universities",
          icon: <FaBalanceScale  />,
          gradient: "linear-gradient(135deg, #13547a 0%, #80d0c7 100%)",
          route: "/courses/law"
        },
        {
          name: "LSAT India",
          description: "Law School Admission Test for various law colleges",
          icon: <FaBalanceScale />,
          gradient: "linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)",
          route: "/courses/lsat"
        },
        {
          name: "MH-CET Law",
          description: "Maharashtra Common Entrance Test for law programs",
          icon: <FaBalanceScale />,
          gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
          route: "/courses/mhcet-law"
        },
        {
          name: "SLAT",
          description: "Symbiosis Law Admission Test for Symbiosis Law Schools",
          icon: <FaBalanceScale />,
          gradient: "linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)",
          route: "/courses/slat"
        },
        {
          name: "DU LLB",
          description: "Delhi University entrance for LLB programs",
          icon: <FaBalanceScale />,
          gradient: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
          route: "/courses/du-llb"
        }
      ]
    }
  ];

  const handleNavigation = (route) => {
    window.location.href = route;
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#fff',
      padding: '40px 20px 60px'
    }}>
      <div className='py-3 my-3' style={{ maxWidth: '1400px', margin: ' auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{
            fontSize: '3rem',
             color: '#000',
             fontWeight:'bold',
             margin: '0  auto',
             padding:'18px'
            
          }}>
            Competitive Exams Programs
          </h1>
          <p style={{ 
            fontSize: '1rem', 
            color: '#000',
            margin: '0 auto'
          }}>

            Comprehensive coaching for every competitive exam from Class 6 to Postgraduate level

          </p>
              <p style={{ 
            fontSize: '0.9rem', 
            color: '#0041f4ff',
            maxWidth:'1100px',
            margin: '0 auto'
          }}>
            We offer comprehensive training programs for national and international competitive exams, including JEE (Engineering), NEET (Medicine), UPSC (Civil Services), CAT (Management), SSC and IBPS (Government Jobs), CLAT (Law), as well as GRE, GMAT, TOEFL, and IELTS for overseas education.
          </p>
        </div>

        {/* Categories */}
        {examCategories.map((category, catIndex) => (
          <div className='mx-auto align-content-center justify-content-center ' key={catIndex} style={{ marginBottom: '60px' }}>
            {/* Category Header */}
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              marginBottom: '30px',
              gap: '15px'
            }}>
              <div style={{
                fontSize: '2.5rem',
                color: 'white',
                background: category.color,
                padding: '15px',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
              }}>
                {category.icon}
              </div>
              <h2 style={{ 
                fontSize: '2rem',
                fontWeight: 'bold',
                color: '#2c3e50',
                margin: 0
              }}>
                {category.title}
              </h2>
            </div>

            {/* Exam Cards Grid */}
            <div className='mx-auto col-10' style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
              gap: '25px'
            }}>
              {category.exams.map((exam, examIndex) => (
                <div
                  key={examIndex}
                  style={{
                    background: 'white',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    border: '1px solid #e8e8e8'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-8px)';
                    e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.08)';
                  }}
                >
                  {/* Card Header */}
                  <div style={{
                    background: exam.gradient,
                    padding: '30px 20px',
                    textAlign: 'center',
                    color: 'white',
                    minHeight: '150px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <div  style={{ fontSize: '3rem', marginBottom: '15px' }}>
                      {exam.icon}
                    </div>
                    <h5 style={{ 
                      fontSize: '1.1rem',
                      fontWeight: 'bold',
                      margin: 0,
                      lineHeight: '1.3'
                    }}>
                      {exam.name}
                    </h5>
                  </div>

                  {/* Card Body */}
                  <div style={{ 
                    padding: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '170px'
                  }}>
                    <p style={{ 
                      fontSize: '0.9rem', 
                      color: '#666', 
                      lineHeight: '1.6',
                      margin: '0 0 20px 0',
                      flex: 1
                    }}>
                      {exam.description}
                    </p>
                    
                    <button 
                      onClick={() => handleNavigation(exam.route)}
                      style={{
                        background: exam.gradient,
                        border: 'none',
                        color: 'white',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        fontWeight: '600',
                        fontSize: '0.95rem',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        width: '100%'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.opacity = '0.9';
                        e.currentTarget.style.transform = 'scale(1.02)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.opacity = '1';
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      View Courses <FaChevronRight size={14} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @media (max-width: 1200px) {
          h1 {
            font-size: 2.5rem !important;
          }
          h2 {
            font-size: 1.75rem !important;
          }
        }
        
        @media (max-width: 768px) {
          h1 {
            font-size: 2rem !important;
          }
          h2 {
            font-size: 1.5rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default CompetitiveExamsSection;